import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { type GuideStoryId } from '@redevicer/shared'
import GuideArticleModal from './GuideArticleModal'
import GuideArticlesList from './GuideArticlesList'

type Props = {
  onBack: () => void
}

export default function GuideArticlesPage({ onBack }: Props) {
  const { t } = useTranslation()
  const [openArticle, setOpenArticle] = useState<GuideStoryId | null>(null)

  return (
    <div className="vc-guide-articles-page">
      <div className="vc-guide-articles-toolbar">
        <button type="button" className="vc-legal-back vc-guide-articles-back" onClick={onBack}>
          ← {t('vc.legal.back')}
        </button>
      </div>
      <header className="vc-guide-articles-head">
        <h2 className="vc-section-title">{t('vc.newsHeading')}</h2>
      </header>
      <GuideArticlesList onOpenFull={setOpenArticle} />
      {openArticle ? <GuideArticleModal storyId={openArticle} onClose={() => setOpenArticle(null)} /> : null}
    </div>
  )
}
